<template>
  <div class="comment-table-container">
    <InfoContainer
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
    >
      <template :slot="InfoContainerConfig['infoContent'][0]['prop']">
        <div class="table-container">
          <el-table
            :data="flowData"
            border
            :show-header="false"
            style="width: 100%">
            <el-table-column
              align="center"
              width="150"
              label="步骤">
              <template slot-scope="scope">
                <div class="step-title">第{{scope.row.num}}步</div>
              </template>      
            </el-table-column>
            <el-table-column
              align="center"
              prop="historyActivityName"
              label="内容">
            </el-table-column>
            <el-table-column
              label="详情"
            >
              <template slot-scope="scope">
                <div class="detail-content">
                  <div class="line-one">
                    <span>{{scope.row.assigneeName}}</span>主办,
                    [ 
                    <span class="work-status" v-if="scope.row.workStatusStr == '办理中'">{{scope.row.workStatusStr}} {{scope.row.historyActivityDurationTime != ''?`,已用时：${scope.row.historyActivityDurationTime}`:''}}</span> 
                    <span class="work-status" v-else>{{scope.row.workStatusStr}} {{scope.row.historyActivityDurationTime != ''?`,用时：${scope.row.historyActivityDurationTime}`:''}}</span> 
                    ]
                  </div>
                  <div class="time-line">开始于: {{scope.row.claimTime?scope.row.claimTime:scope.row.createTime}}</div>
                  <div class="time-line">结束于: {{scope.row.endTime}}</div>
                </div>
              </template>
            </el-table-column>
          </el-table>          
        </div>
      </template>
    </InfoContainer>
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/infoContainer";
export default {
  name: 'CommentTable',
  data() {
    return {
      tableData: [],
      InfoContainerConfig: {
        infoTitle: '流程记录',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      }      
    }
  },
  props: {
    flowData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    InfoContainer
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.comment-table-container{
  .table-container{
    .step-title{
      font-size: 13px;
      color: #333;
      margin-bottom: 10px;
      font-weight: 700;
    }
    .detail-content{
      .line-one{
        line-height: 19px;
        font-size: 15px;
        color: #333;
        font-weight: 400; 
        span{
          font-size: 15px;
          color: #FF3B30;
          font-weight: 400;
          line-height: 19px;
        }
        .work-status{
          color: green;
        }
      }
      .time-line{
        font-size: 13px;
        color: #333;
      }
    }
  }
}
</style>